import { createIcon } from '@chakra-ui/icons';

export const RecipeBook = createIcon({
  displayName: 'RecipeBook',
  viewBox: '0 0 12 12',
  path: [
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_916_24009)">
        <path d="M12 2.25H10.5V4.5H12V2.25Z" fill="currentColor" />
        <path d="M12 5.25H10.5V7.5H12V5.25Z" fill="currentColor" />
        <path
          d="M7.5 0H0.75C0.3 0 0 0.3 0 0.75V11.25C0 11.7 0.3 12 0.75 12H7.5C8.775 12 9.75 11.025 9.75 9.75V2.25C9.75 0.975 8.775 0 7.5 0ZM6.75 6H3V3H6.75V6Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_916_24009">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
